import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'loading',
  template: `<div class="flex">
    <div class="item"><div class="loading"><span class="loading-wave"></span></div></div>
    <div class="item text">Loading ...</div>
  </div>`,
  styleUrls: ['./loading.component.scss']
})
export class LoadingIndicatorComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/loading/loading.component.ts